/*
  pof-countdown: a small countdown timer.

  How it works:
  1. Reads the end time from the data-target attribute (set in Liquid).
  2. Every second, calculates how much time is left and updates the numbers.
  3. When the time is up, hides the numbers and shows the "ended" text.
*/

if (!customElements.get('pof-countdown')) {
  class PofCountdown extends HTMLElement {
    connectedCallback() {
      this.target = new Date(this.dataset.target).getTime();

      // If the date in the theme settings is not valid, hide the timer.
      if (Number.isNaN(this.target)) {
        this.hidden = true;
        return;
      }

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      // Stop the timer when the element is removed (e.g. in the theme editor).
      clearInterval(this.timer);
    }

    tick() {
      const msLeft = this.target - Date.now();

      if (msLeft <= 0) {
        clearInterval(this.timer);
        const grid = this.querySelector('.pof-countdown__grid');
        const ended = this.querySelector('.pof-countdown__ended');
        if (grid) grid.hidden = true;
        if (ended) ended.hidden = false;
        this.classList.add('is-ended');
        // Tell the rest of the page (e.g. the pre-order box) that time is up.
        this.dispatchEvent(new CustomEvent('pof:countdown-ended', { bubbles: true }));
        return;
      }

      const totalSeconds = Math.floor(msLeft / 1000);
      const parts = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
      };

      // padStart turns 7 into "07" so the numbers don't jump around.
      // (We look the numbers up every tick, so it also works while the page is still loading.)
      this.querySelectorAll('[data-unit]').forEach((el) => {
        el.textContent = String(parts[el.dataset.unit]).padStart(2, '0');
      });
    }
  }

  customElements.define('pof-countdown', PofCountdown);
}
